module.exports = __webpack_public_path__ + "assets/contrastIcon-06e076.svg";